import React from 'react';
import { Box, Button } from '@mui/material';

const OverviewMenuButtons = ({
  buttons = [],
  selected,
  onButtonClick,
  containerStyles = {},
  buttonStyles = {},
}) => {
  return (
    <Box
      sx={{
        border: '1px solid #1D3899', // Default border color
        borderRadius: '50px', // Default rounded border
        padding: 2,
        display:'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#fff', // Default background color
        ...containerStyles, // Custom styles
      }}
    >
      {buttons.map((button) => (
        <Button
          key={button.value}
          onClick={() => onButtonClick(button.value)}
          sx={{
            backgroundColor: selected === button.value ? '#1D3899' : '#fff',
            color: selected === button.value ? '#fff' : '#000000',
            borderRadius: '40px',
           
            fontSize: '0.9rem',
            fontWeight: 'bold',
            textTransform: 'capitalize',
            border: selected === button.value ? '1px solid #1D3899' : '',
            '&:hover': {
              backgroundColor: selected === button.value ? '#174282' : '#f9f9f9',
            },
            margin: '0 8px',
            ...buttonStyles, // Custom styles
          }}
        >
          {button.label}
        </Button>
      ))}
    </Box>
  );
};

export default OverviewMenuButtons;
